import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/empty-denounce-comment-forum.svg'
import _imports_1 from '@/assets/images/empty-denounce-topic-forum.svg'
import _imports_2 from '@/assets/images/result-empty.svg'
import _imports_3 from '@/assets/images/user-topic.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid grid-cols-1 md:flex gap-4 items-center mt-8 mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "empty denounces",
  class: "w-[657px] mx-auto flex mt-32"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "empty denounces",
  class: "w-[657px] mx-auto flex mt-32"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col items-center justify-center w-full mt-16"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "empty results",
  class: "w-[37vw] md:w-[8vw] min-w-[136px]"
}, null, -1)
const _hoisted_8 = { class: "w-[80vw] md:w-full text-center text-base gap-2 flex flex-col mt-4 text-h-neutral-700 justify-center items-center" }
const _hoisted_9 = { class: "font-extrabold" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_13 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white border border-gray-300 rounded-lg" }, null, -1)
const _hoisted_15 = { class: "flex justify-start w-full" }
const _hoisted_16 = {
  key: 0,
  class: "text-xl !font-medium text-black"
}
const _hoisted_17 = {
  key: 1,
  class: "text-xl !font-medium text-black"
}
const _hoisted_18 = { class: "w-full min-h-[calc(100vh-128px)] p-4 flex items-center justify-center overflow-auto" }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = { class: "h-4/5 w-full" }
const _hoisted_21 = { class: "flex items-center mb-6" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
  src: _imports_3,
  alt: "user"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "text-base font-bold text-h-neutral-700" }
const _hoisted_28 = { class: "text-sm text-h-neutral-700" }
const _hoisted_29 = { class: "custom-quill" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 2,
  class: "!w-full flex justify-center bg-black mt-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DenoucedGroupList = _resolveComponent("DenoucedGroupList")!
  const _component_TableDenounces = _resolveComponent("TableDenounces")!
  const _component_Image = _resolveComponent("Image")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, { loader: _ctx.isLoading }, null, 8, ["loader"]),
    (!_ctx.isLoading && !_ctx.showDenounces)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.denounceType,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.denounceType) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDataTable()))
              ],
              options: _ctx.options,
              "aria-labelledby": "basic",
              class: "custom-buttonSelectForum col-span-12 md:col-span-4",
              unselectable: false,
              hasStatus: false
            }, null, 8, ["modelValue", "options"]),
            (
            _ctx.denounceType ===
            _ctx.$t('labels.generic', {
              pt: 'Tópicos',
              en: 'Topics',
            })
          )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["p-input-icon-left col-span-12 md:col-span-3", { 'p-input-icon-right': _ctx.params.title }])
                }, [
                  _hoisted_3,
                  _createVNode(_component_InputText, {
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.getDenouncesByTopicTitle()), ["enter"])),
                    type: "text",
                    modelValue: _ctx.inputTopicTitle,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputTopicTitle) = $event)),
                    placeholder: 
              _ctx.$t('labels.generic', {
                pt: 'Pesquisar por tópico',
                en: 'Search by topic',
              })
            ,
                    class: "p-inputtext-sm h-[36px]"
                  }, null, 8, ["modelValue", "placeholder"]),
                  (_ctx.params.title)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "pi pi-times",
                        role: "button",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                      }))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            _createVNode(_component_Dropdown, {
              onChange: _ctx.getDenouncesByStatus,
              options: _ctx.optionsStatusFilter,
              class: "h-[36px] items-center flex col-span-12 md:col-span-3",
              modelValue: _ctx.statusOfDenounce,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.statusOfDenounce) = $event)),
              optionLabel: "label"
            }, null, 8, ["onChange", "options", "modelValue"])
          ]),
          (
          _ctx.totalDenounces === 0 &&
          _ctx.denounceType ===
            _ctx.$t('labels.generic', {
              pt: 'Comentários',
              en: 'Comments',
            })
        )
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (
          _ctx.totalDenounces === 0 &&
          _ctx.denounceType ===
            _ctx.$t('labels.generic', {
              pt: 'Tópicos',
              en: 'Topics',
            })
        )
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_ctx.params.title && _ctx.totalDenounces === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", { pt: "Sem resultados", en: "No results" })), 1),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Não foram encontrados denúncias com o termo pesquisado.",
                en: "No denounces were found with the search term.",
              })), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearParams && _ctx.clearParams(...args))),
                      class: "border btn-outline min-w-[143px] rounded font-bold h-8 w-[39vw] md:w-[9.9vw] mt-6 flex items-center justify-center text-base mb-32"
                    }, _toDisplayString(_ctx.$t("labels.generic", { pt: "Limpar pesquisa", en: "Clean search" })), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_ctx.denounceType === _ctx.options[1])
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(_ctx.$t("forum.listDenounces.topics.title")), 1))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_13, _toDisplayString(_ctx.$t("forum.listDenounces.comments.title")), 1)),
                    _hoisted_14,
                    _createVNode(_component_DenoucedGroupList, {
                      commentsDenouncesList: _ctx.commentsDenouncesList,
                      topicsDenouncesList: _ctx.topicsDenouncesList,
                      statusOfDenounce: _ctx.statusOfDenounce,
                      denounceType: _ctx.denounceType,
                      size: _ctx.numberOfDenouncesPerPage,
                      total: _ctx.totalDenounces,
                      onPaginate: _ctx.changePage,
                      onDenounces: _ctx.setTableOfDenounces,
                      onDisplayedItem: _ctx.setDisplayedItem
                    }, null, 8, ["commentsDenouncesList", "topicsDenouncesList", "statusOfDenounce", "denounceType", "size", "total", "onPaginate", "onDenounces", "onDisplayedItem"])
                  ]))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("section", null, [
      _createVNode(_component_TableDenounces, {
        denounceComments: _ctx.denounceComment,
        denounceTopic: _ctx.denounceTopic,
        denounceType: _ctx.denounceType,
        onCloseTableDenounces: _ctx.closeTableDenounces,
        onDisplayedItem: _ctx.setDisplayedItem,
        onUpdateDenounces: _ctx.getDenouncesByType
      }, null, 8, ["denounceComments", "denounceTopic", "denounceType", "onCloseTableDenounces", "onDisplayedItem", "onUpdateDenounces"])
    ], 512), [
      [_vShow, _ctx.showDenounces]
    ]),
    _createVNode(_component_Dialog, {
      modal: true,
      visible: _ctx.isVisibleDisplayedItemDialog,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isVisibleDisplayedItemDialog) = $event)),
      style: { maxWidth: '780px', height: '100vh' },
      class: "w-11/12 custom-dialogForum"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          (_ctx.isCommentDenounces())
            ? (_openBlock(), _createElementBlock("h2", _hoisted_16, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Comentário denúnciado",
                en: "Reported comment",
              })), 1))
            : (_openBlock(), _createElementBlock("h2", _hoisted_17, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Tópico denúnciado",
                en: "Reported topic",
              })), 1))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "h-8 !py-1.5 !px-2 flex gap-1 btn-primary",
          severity: "secondary",
          autofocus: "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleStateDisplayedItemDialog(false), (_ctx.showDenounces = true)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { name: "md-listalt-round" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", { pt: "Ver denúncias", en: "See reports" })), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("header", _hoisted_21, [
                (!_ctx.displayedItem.userAuthor.photoProfile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                  : (_ctx.displayedItem.userAuthor.photoProfile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("img", {
                          class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
                          src: _ctx.displayedItem.userAuthor.photoProfile.path,
                          alt: "user"
                        }, null, 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("h6", _hoisted_27, _toDisplayString(_ctx.displayedItem?.userAuthor?.name), 1),
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Publicado em",
                      en: "Published in",
                    })) + " " + _toDisplayString(_ctx.showCreationDate(_ctx.displayedItem.created)), 1)
                ])
              ]),
              _withDirectives(_createElementVNode("h4", { class: "text-2xl leading-8 font-medium break-all" }, _toDisplayString(_ctx.displayedItem.title), 513), [
                [_vShow, !_ctx.isCommentDenounces()]
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.isCommentDenounces())
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      innerHTML: _ctx.displayedItem.comment,
                      class: "ql-editor !p-0 mt-4 text-[14px]"
                    }, null, 8, _hoisted_30))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: _ctx.displayedItem.description,
                      class: "ql-editor !p-0 mt-4 text-[14px]"
                    }, null, 8, _hoisted_31)),
                (_ctx.displayedItem.media)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_Image, {
                        src: _ctx.displayedItem.media.path,
                        alt: "topic image",
                        preview: "",
                        imageClass: "!w-full !object-cover !h-[600px] !min-h-[150px] !max-h-[450px] "
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}